<template>
    <div v-if="showDeletionAlert" class="container-fluid" id="delete_account_notification">
        This account is scheduled to delete.
        <span v-if="showCancelPanel">
            You can delete it immediately by clicking the link sent to your email.
            (<a @click.prevent="resendEmail" href="javascript:;">Click here</a> to send new confirmation email -
            (this will invalidate previous email) to delete your account or
            <a @click.prevent="cancelDeletionRequest" href="javascript:;">cancel deletion</a>.
        </span>
    </div>
</template>

<script>
    import notifications from '~/vue/plugins/notifications';
    import {simplePopupFactory} from 'shared/simple_popups/simplePopupFactory';
    import globalEventBus, {GLOBAL_EVENTS} from 'shared/globalEventBus';
    import {CurrentUserClass} from 'shared/CurrentUser';
    import userprofileSettingsResourceImport from '../userprofile_settings_resource';
    import { hideDimmer } from 'shared/utils/dimmer';

    const UserProfileSettingsResource = userprofileSettingsResourceImport();

    export default {
        name: "DeleteAccountNotification",
        data() {
            return {
                currentUser: new CurrentUserClass(),
            };
        },
        computed: {
            // reads the viewer directly rather than copying it into data: cancelling the
            // deletion clears the flag on the store, from here or from the settings page,
            // and the banner goes away on its own
            showDeletionAlert() {
                return this.currentUser.pending_to_delete;
            },
            showCancelPanel() {
                return !this.currentUser.is_circle_user();
            },
        },
        methods: {
            resendEmail() {
                UserProfileSettingsResource.resend_close_account_confirmation_email(this.currentUser.id)
                    .then(() => {
                        notifications.success('You will receive an email with a confirmation link shortly.', 5000);
                    }, err => {
                        notifications.error(err || 'Error');
                    });
            },
            cancelDeletionRequest() {
                simplePopupFactory.show_popup('Cancel account deletion', 'Are you sure you want to cancel deletion this account?', 'Cancel Deletion', 'No')
                    .then(() => UserProfileSettingsResource.cancel_account_deletion(this.currentUser.id),
                        () => new Promise(() => {
                        }))
                    .then(() => {
                        // the settings page listens for this on the global event bus
                        globalEventBus.emit(GLOBAL_EVENTS.ACCOUNT_DELETION_CANCELLED, true);
                        notifications.success(`Account deletion has been canceled`);
                    }, err => notifications.error(err || 'Error'))
                    .finally(() => hideDimmer());
            },
        },
        created() {
            this.unsubscribe = globalEventBus.subscribe({
                [GLOBAL_EVENTS.ACCOUNT_DELETION_CANCELLED]: () => {
                    this.currentUser.pending_to_delete = false;
                }
            });
        },
        beforeUnmount() {
            this.unsubscribe();
        },
    };
</script>
